
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PaymentsSharedSetupPaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetupPaymentMethodInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setupPaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetupPaymentMethodError"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SetupPaymentGatewayError"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetupPaymentMethodSuccess"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentsSharedSetupPaymentMethodSuccessFields"},"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentsSharedSetupPaymentMethodSuccessFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetupPaymentMethodSuccess"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gatewayData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetupPaymentMethodStripeGatewayData"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentsSharedSetupPaymentStripeFields"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetupPaymentMethodDLocalGatewayData"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentsSharedSetupPaymentDLocalFields"},"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentsSharedSetupPaymentStripeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetupPaymentMethodStripeGatewayData"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setupIntent"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSecret"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accountId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodId"},"arguments":[],"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentsSharedSetupPaymentDLocalFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetupPaymentMethodDLocalGatewayData"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accountId"},"arguments":[],"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SetupPaymentGatewayError"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SetupPaymentMethodError"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gatewayErrorData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"declineCode"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1013}};
    doc.loc.source = {"body":"mutation PaymentsSharedSetupPaymentMethod($input: SetupPaymentMethodInput!) {\n\tsetupPaymentMethod(input: $input) {\n\t\t__typename\n\t\t... on SetupPaymentMethodError {\n\t\t\t...SetupPaymentGatewayError\n\t\t}\n\t\t... on SetupPaymentMethodSuccess {\n\t\t\t...PaymentsSharedSetupPaymentMethodSuccessFields\n\t\t}\n\t}\n}\nfragment PaymentsSharedSetupPaymentMethodSuccessFields on SetupPaymentMethodSuccess {\n\tgatewayData {\n\t\t__typename\n\n\t\t... on SetupPaymentMethodStripeGatewayData {\n\t\t\t...PaymentsSharedSetupPaymentStripeFields\n\t\t}\n\n\t\t... on SetupPaymentMethodDLocalGatewayData {\n\t\t\t...PaymentsSharedSetupPaymentDLocalFields\n\t\t}\n\t}\n}\nfragment PaymentsSharedSetupPaymentStripeFields on SetupPaymentMethodStripeGatewayData {\n\tsetupIntent {\n\t\tclientSecret\n\t\taccountId\n\t\tpaymentMethodId\n\t}\n}\nfragment PaymentsSharedSetupPaymentDLocalFields on SetupPaymentMethodDLocalGatewayData {\n\tcard {\n\t\tid\n\t\taccountId\n\t}\n}\nfragment SetupPaymentGatewayError on SetupPaymentMethodError {\n\tmessage\n\ttype\n\tgatewayErrorData {\n\t\tcode\n\t\ttype\n\t\tdeclineCode\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PaymentsSharedSetupPaymentMethod"] = oneQuery(doc, "PaymentsSharedSetupPaymentMethod");
        
        module.exports["PaymentsSharedSetupPaymentMethodSuccessFields"] = oneQuery(doc, "PaymentsSharedSetupPaymentMethodSuccessFields");
        
        module.exports["PaymentsSharedSetupPaymentStripeFields"] = oneQuery(doc, "PaymentsSharedSetupPaymentStripeFields");
        
        module.exports["PaymentsSharedSetupPaymentDLocalFields"] = oneQuery(doc, "PaymentsSharedSetupPaymentDLocalFields");
        
        module.exports["SetupPaymentGatewayError"] = oneQuery(doc, "SetupPaymentGatewayError");
        
